class StateService {
  /*static StatesColumn = [
    {
      id: 1,
      name: "LABRADA",
      column: "LABRADAS",
      color: "#00c3a8",
    },
    {
      id: 2,
      name: "NOTIFICADA",
      column: "NOTIFICADAS",
      color: "#ffb900",
    },
    {
      id: [3, 6],
      name: ["DESCARGO", "RECURRIDA"], // Fusionados
      column: "PARA SENTENCIA",
      color: "#ff2745",
    },
    {
      id: 4,
      name: "SENTENCIA",
      column: "SENTENCIADAS",
      color: "#0057d9",
    },
    {
      id: 5,
      name: "SENTENCIA FIRME",
      column: "SENTENCIADAS FIRMES",
      color: "#009688",
    },
    {
      id: 7,
      name: "PAGADA",
      column: "PAGADAS",
      color: "#8bc34a",
    },
    {
      id: 8,
      name: "CANCELADA",
      column: "CANCELADAS",
      color: "#f44336",
    },
    {
      id: 9,
      name: "ARCHIVADA",
      column: "ARCHIVADAS",
      color: "#9e9e9e",
    },
  ];*/

  static StatesColumn = [
    {
      id: 1,
      name: "LABRADA",
      column: "LABRADAS",
      color: "#00c3a8",
    },
    {
      id: 2,
      name: "NOTIFICADA",
      column: "NOTIFICADAS",
      color: "var(--color-yellow-muni)",
    },
    {
      id: [3, 6],
      name: ["RECURRIDA", "DESCARGO"], // Fusionados
      column: "PARA SENTENCIA",
      color: "#ff2745",
    },
    {
      id: [4, 5],
      name: ["SENTENCIA", "SENTENCIA FIRME"],
      column: "CON SENTENCIA",
      color: "#0057d9",
    },
    {
      id: [7, 8, 9, 10],
      name: ["PAGADA", "DESESTIMADA", "ARCHIVADA", "ANULADA"],
      column: "ARCHIVADAS",
      color: "#9e9e9e",
    },
    {
      id: 10,
      name: "ANULADA",
      column: "ANULADAS",
      color: "#9e9e9e",
    },
  ];

  static stateAction = [
    {
      id: 1,
      name: "LABRADA",
      action: "LABRAR",
      color: "#00c3a8",
      column: "LABRADAS",
      toList: "LABRADAS"
    },
    {
      id: 2,
      name: "NOTIFICADA",
      action: "NOTIFICAR",
      color: "var(--color-yellow-muni)",
      column: "NOTIFICADAS",
      toList: "NOTIFICADAS"
    },
    {
      id: 3,
      name: "DESCARGO", 
      action: "DESCARGO",
      color: "#ff2745",
      column: "DESCARGO",
      toList: "CON DESCARGO"
    },
    {
      id: 4,
      name: "SENTENCIA",
      action: "SENTENCIAR",
      color: "#0057d9",
      column: "SENTENCIADAS",
      toList: "SENTENCIADAS"
    },
    {
      id: 5,
      name: "RECURRIDA", 
      action: "RECURRIR",
      color: "#ff2745",
      column: "RECURRIDAS",
      toList: "RECURRIDAS"
    },
    {
      id: 6,
      name: "SENTENCIA FIRME",
      action: "SENTENCIAR",
      color: "#009688",
      column: "SENTENCIADAS FIRMES",
      toList: "SENTENCIADAS FIRMES"
    },
    {
      id: 7,
      name: "PAGADA",
      action: "PAGAR",
      color: "#8bc34a",
      column: "ARCHIVADAS", // debe coincidir con el name en el array de statescolumn
      toList: "PAGADAS"
    },
    {
      id: 8,
      name: "DESESTIMADA",
      action: "DESESTIMAR",
      color: "#f44336",
      column: "ARCHIVADAS",
      toList: "DESESTIMADAS"
    },
    {
      id: 9,
      name: "ARCHIVADA",
      action: "ARCHIVAR",
      color: "#9e9e9e",
      column: "ARCHIVADAS",
      toList: "ARCHIVADAS"
    },
    {
      id: 10,
      name: "ANULADA",
      action: "ANULAR",
      color: "#f44336",
      column: "ARCHIVADAS",
      toList: "ANULADAS"
    },]
}

export default StateService;
